import { useCallback, useRef } from 'react';

const useDebounce = (cb, delay = 500) => {
  const timeout = useRef(null);

  return useCallback(
    (...args) => {
      if (timeout.current) clearTimeout(timeout.current);

      timeout.current = setTimeout(() => {
        return cb(...args);
      }, delay);
    },
    [cb, delay]
  );
};

export default useDebounce;
